import dayjs from 'dayjs'

const setLocalStorage = (key, val) => {
  let handleVal = val
  if (typeof val === 'object') {
    handleVal = JSON.stringify(val)
  }
  localStorage.setItem(key, handleVal)
}
const getLocalStorage = (key, type) => {
  const res = localStorage.getItem(key)
  if (!res || res === 'undefined') {
    return ''
  }
  if (type) {
    return JSON.parse(res)
  }
  return res
}
const CHATGLM_APPLY_PHONE_NUMBER = 'chatglm_apply_phone_number'
const IS_FISRT_VIEW_AFTER_APPLY = 'isFisrtViewAfterApply'

const PROMPT_VISITED_LIST = 'prompt_visited_list'

const DETAIL_INIT_PAGE_SHOW_TIME = 'detail_init_page_show_time'

const SHOW_UPLOAD_ANIMATE = 'showUploadAnimate'

export function showOneperDay(key) {
  const days = dayjs()
  const today = days.format('YYYY-MM-DD')
  const last = getLocalStorage(key)
  if (!last || today > last) {
    setLocalStorage(key, today)
    return true
  } else {
    return false
  }
}

export {
  setLocalStorage,
  getLocalStorage,
  IS_FISRT_VIEW_AFTER_APPLY,
  CHATGLM_APPLY_PHONE_NUMBER,
  PROMPT_VISITED_LIST,
  DETAIL_INIT_PAGE_SHOW_TIME,
  SHOW_UPLOAD_ANIMATE
}
